import React from 'react';
import PropTypes from 'prop-types';
import { alertTypes } from './constants';
import {
  BaseAlert,
  ErrorAlert,
  InfoAlert,
  NoContentAlert,
  SuccessAlert
} from './components';

export * from './components';
export { alertTypes } from './constants';

export const AlertSet = ({ type, alertObjects }) => {
  const content = alertObjects.map(obj => (
    <Alert
      type={type}
      header={obj.header}
      content={obj.message}
      key={`alertset-${Math.random() * 100000}`}
      onDismiss={obj.onDismiss}
    />
  ));
  return <div>{content}</div>;
};

AlertSet.propTypes = {
  type: PropTypes.oneOf(Object.keys(alertTypes)).isRequired,
  alertObjects: PropTypes.array.isRequired
};

export const Alert = ({
  content,
  header,
  onDismiss,
  type,
  ...rest
}) => {
  switch (type) {
    case alertTypes.ERROR:
      return (
        <ErrorAlert
          {...rest}
          header={header}
          content={content}
          onDismiss={onDismiss}
        />
      );
    case alertTypes.SUCCESS:
      return (
        <SuccessAlert
          {...rest}
          header={header}
          content={content}
          onDismiss={onDismiss}
        />
      );
    case alertTypes.DEFAULT:
      return (
        <BaseAlert
          {...rest}
          header={header}
          content={content}
          onDismiss={onDismiss}
        />
      );
    case alertTypes.NO_CONTENT:
      return (
        <NoContentAlert
          {...rest}
          header={header}
          content={content}
          onDismiss={onDismiss}
        />
      );
    case alertTypes.INFO:
    default:
      return (
        <InfoAlert
          {...rest}
          header={header}
          content={content}
          onDismiss={onDismiss}
        />
      );
  }
};

Alert.propTypes = {
  type: PropTypes.oneOf(Object.keys(alertTypes)),
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  onDismiss: PropTypes.func
};
Alert.defaultProps = {
  type: alertTypes.INFO,
  header: undefined,
  onDismiss: undefined
};

export default Alert;
